import { Injectable, Renderer2 } from '@angular/core';
import { Observable } from 'rxjs';
import { CleverPushNotification, CleverPushPlatform, CleverPushTopicType } from '../entities/clever-push.entity';

export interface CleverPushSetupConfig {
  renderer?: Renderer2;
}

export interface CleverPushOptInResult {
  subscriptionId: string | null;
  hasSubscribed: boolean;
}

export const FEATURE_STORAGE_KEY = 'clever-push-feature-enabled';

export type CleverPushConversionEvent = 'Home_Besucht_nach_Login';

@Injectable({ providedIn: 'root' })
export abstract class CleverPushService {
  public abstract ready$: Observable<boolean>;
  public abstract notifications$: Observable<CleverPushNotification<undefined | CleverPushTopicType>[]>;
  public abstract hasPermission$: Observable<boolean>;
  public abstract setup(config?: CleverPushSetupConfig): Promise<unknown>;
  public abstract getSubscriptionId(): Promise<string | null>;
  public abstract setAuthToken(): Promise<void>;
  public abstract processSubscriptionIdAfterLogin(): Promise<void>;
  public abstract removeSubscriptionIdAfterLogout(): Promise<void>;
  public abstract authorize(): Promise<void>;
  public abstract hasSubscribed(): Promise<boolean>;
  public abstract requestPermission(): Promise<boolean>;
  public abstract hasPermission(): Promise<boolean>;
  public abstract subscribe(): Promise<string | null>;
  public abstract unsubscribe(): Promise<void>;
  public abstract getTopics(): Promise<string[]>;
  public abstract setTopics(topics: string[]): Promise<void>;
  public abstract getNotifications(): Promise<CleverPushNotification<undefined | CleverPushTopicType>[]>;
  public abstract setAuthorizerToken(token: string): Promise<void>;
  public abstract tagSubscription(tagId: string): Promise<void>;
  public abstract untagSubscription(tagId: string): Promise<void>;
  public abstract getAttribute(key: string): Promise<string | null>;
  public abstract hasAttribute(key: string): Promise<boolean>;
  public abstract isFeatureEnabled(): Promise<boolean>;
  public abstract enableFeature?(): Promise<void>;
  public abstract disableFeature?(): Promise<void>;
  public abstract getPlatform(): CleverPushPlatform;
  public abstract trackEvent(eventName: CleverPushConversionEvent, properties?: Record<string, unknown>): Promise<void>;
}
